<template>
  <!-- :bodyStyle="{paddingTop:'0px'}" :headStyle="{borderBottom:'0px'}" -->
  <a-card :bordered="false" :headStyle="{ borderBottom: '0px', fontSize: '18px' }">
    <a-row slot="title">
      <a-col :span="24">
        <span class="card-title">交易对账单</span>
        <span class="card-content">对账周期为系统默认不可修改，如需更改对账周期请联系您的商务经理</span>
      </a-col>
    </a-row>
    <a-form>
      <search-header :col="3">
        <search-list>
          <a-form-item label="结算周期" v-bind="searchItemLayout">
            <a-range-picker @change="onDateChange" :value="selectedDate" style="width: 100%;"/>
          </a-form-item>
          <a-form-item label="对账状态" v-bind="searchItemLayout">
            <a-select allowClear style="width: 100%;" v-model="queryParams.statementStatus" placeholder="请选择">
              <a-select-option v-for="item in accountDataList" :key="item.code" :value="item.code"
              >{{ item.name }}
              </a-select-option>
            </a-select>
          </a-form-item>
          <a-form-item style="margin-left: 2%;">
            <a-button type="primary" @click="$refs.table.refresh(true)">查询</a-button>
            <a-button @click="toStatement">查看已生成报表</a-button>
          </a-form-item>
        </search-list>
      </search-header>
    </a-form>
    <custom-page-table
      ref="table"
      rowKey="statementId"
      :columns="columns"
      :queryParams="queryParams"
      :requestPromise="loadPromise"
    >
      <div slot="dateSlots" slot-scope="data">
        {{ data.record.statementStartDate }}至{{ data.record.statementEndDate }}
      </div>
      <div slot="statementStatus" slot-scope="data">
        {{ data.text | statementStatusName }}
      </div>
      <div slot="statementIncomeTotal" slot-scope="data">+{{ data.text }}</div>
      <div slot="statementExpenditureTotal" slot-scope="data">{{ data.text }}</div>
      <div slot="action" slot-scope="data">
        <a @click="toDetail(data.record)">查看详情</a>
        <a-divider type="vertical"/>
        <a @click="downloadBill(data.record)">下载账单</a>
      </div>
    </custom-page-table>
  </a-card>
</template>

<script>
import searchForm from '@/utils/mixins/searchFormMixins'

export default {
  name: 'AccountCheck',
  mixins: [searchForm],
  data() {
    return {
      selectedDate: undefined,
      statusList: [],
      queryParams: {},
      accountDataList: [],
      loadPromise: params => this.getAccountData(params),
      columns: [
        {
          title: '结算周期',
          dataIndex: 'statementEndDate',
          scopedSlots: { customRender: 'dateSlots' }
        },
        {
          title: '本期收入合计',
          dataIndex: 'statementIncomeTotal',
          scopedSlots: { customRender: 'statementIncomeTotal' }
        },
        {
          title: '本期支出合计',
          dataIndex: 'statementExpenditureTotal',
          scopedSlots: { customRender: 'statementExpenditureTotal' }
        },
        {
          title: '上期账户余额',
          dataIndex: 'statementPreviousBalance'
        },
        {
          title: '当前账户余额',
          dataIndex: 'statementCurrentBalance'
        },
        {
          title: '平台调整金额',
          dataIndex: 'statementAdjustmentAmount'
        },
        {
          title: '合计应付总额',
          dataIndex: 'statementTotalAmount'
        },
        {
          title: '对账状态',
          dataIndex: 'statementStatus',
          scopedSlots: { customRender: 'statementStatus' }
        },
        {
          title: '操作',
          dataIndex: 'action',
          scopedSlots: { customRender: 'action' },
          fixed: 'right',
          width: '170px'
        }
      ]
    }
  },
  mounted() {
    this.accountDataList = this.getAppConstants().getStatementStatus()
  },
  methods: {
    toStatement() {
      this.$router.push({
        name: 'DownloadTable'
      })
    },
    getAccountData(params) {
      return this.getHttpServices().getUserService().post('api/v2/financialTransactionr/selectAccountsMerchantList', params)
    },
    //日期变更
    onDateChange(dates, dateStrArr) {
      this.selectedDate = dates
      this.queryParams.statementStartDate = dateStrArr[0]//出游开始日期
      this.queryParams.statementEndDate = dateStrArr[1]//出游结束日期
    },
    toDetail(record) {
      this.getLogUtils().logWithTag('record==', record)
      this.$router.push({
        name: 'CheckUnitDetails',
        query: { statementId: record.statementId }
      })
    },
    downloadBill(record) {
      const rowsId = 'api/v2/financialTransactionr/downloadBill/' + record.statementId
      this.getLogUtils().logWithTag('------------', record.statementId)
      this.getHttpServices().getUserService().get(rowsId)
        .then(detail => {
          this.$message.success('成功下载')
        }).catch(reason => {
        this.showNetWorkErrorMessage(reason)
        this.$message.error('下载失败')
      })
    }
  }
}
</script>
<style scoped lang="less">
.ant-btn + .ant-btn {
  margin-left: 5px;
}

.card-title {
  font-size: 18px;
  font-weight: 500;
  color: #000;
  margin-right: 15px;
}

.card-content {
  font-size: 14px;
  color: #000;
}
</style>